/**
 * Gateway origin, resolved identically to `src/lib/rest_client.ts` but duplicated here rather than
 * imported from it — guest code (`src/guest/**`, `src/components/guest/**`) is lint-forbidden from
 * importing `@/lib/rest_client` at all, because that module imports `@/lib/keycloak`, and the guest
 * shell runs pre-Keycloak on `/p` (ADR-001 Amendment 1). This is the one gateway-origin constant
 * guest code may import in P0d.
 */
export const GATEWAY_URL =
  (import.meta.env.VITE_GATEWAY_URL as string | undefined) ??
  (import.meta.env.VITE_GRAPHQL_URL as string | undefined)?.replace(/\/graphql\/?$/, '') ??
  'http://localhost:4000';
